module.exports = __webpack_public_path__ + "26fb55fc7e2b9d35f0ac5950dfba0fe8.pdf";